const DEFAULT_CODE_LENGTH = 6;
const SECRET_GROUP_SIZE = 4;

export const sanitizeAuthenticatorCode = (input: string, digits: number = DEFAULT_CODE_LENGTH): string =>
	input.replace(/\D/g, "").slice(0, digits);

export const isCompleteAuthenticatorCode = (code: string, digits: number = DEFAULT_CODE_LENGTH): boolean =>
	code.length === digits;

export const formatSecretForManualEntry = (secretBase32Encoded: string): string => {
	const normalized = secretBase32Encoded.replace(/\s/g, "").toUpperCase();
	const groups: string[] = [];
	for (let index = 0; index < normalized.length; index += SECRET_GROUP_SIZE) {
		groups.push(normalized.slice(index, index + SECRET_GROUP_SIZE));
	}
	return groups.join(" ");
};

export const isValidDisableCode = (code: string): boolean => code.trim().length > 0;
